import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NgxPaginationModule } from 'ngx-pagination';
import { MdbTableModule, MdbTablePaginationComponent } from 'mdb5-adapted';

import { LMS_PaginateDirective } from '../lms-paginate';
import { LmsPaginateModule } from '../lms-paginate/lms-paginate.module';
import { LmsGridviewComponent } from './lms-gridview.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    NgxPaginationModule,
    LMS_PaginateDirective,
    MdbTableModule,
    LmsGridviewComponent,
    LmsPaginateModule
  ],
  exports:[
    LmsGridviewComponent,
    LMS_PaginateDirective
  ]
})
export class LmsGridviewModule { }
